import React,{useState, useEffect, Component} from 'react';
import Header from './Headers';
import Estudiopacientes from './estudiospacientes';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Moment from 'react-moment';
import axios from 'axios'; 


const Derivante = () => {


    const baseUrl="//localhost:9090";

    const [datas, setData]=useState([]);
    const [datosEstudios,setDataEstudios]=useState([]);
    const [modalInsertar, setModalInsertar]=useState(false);
    const [modalEliminar, setModalElimnar]=useState(false);
    const [modalAgregarestudio, setModalAgregarEstudio]=useState(false);
    const [modalVerEstudios, setModalVerEstudios]=useState(false);
    

    const [pacienteSeleccionado, setinsertPaciente]= useState({
        id:'',
        nombre:'',
        dni:'',    
        domicilio:'',
        localidad:'',
        telefono:'',
        correo:'',
        activo:'', 
        direccion:''
    });

    const [estudioSeleccionado, setinsertEstudio]=useState({
       codigo:'',
       nombre: '',
       fechanetrega: '',
       fechapedido:''

    });

    const handleChange=e=>{
        const {name,value}=e.target;
        setinsertPaciente((prevestate)=>({
            ...prevestate,
            [name]: value
        }))
      
    }

    const handleChangestudio=e=>{
        const {name,value}=e.target;
        setinsertEstudio((prevestate)=>({
            ...prevestate,
            [name]: value
        }))
    }

    const abrirModalVerEstudios=()=>{
        setModalVerEstudios(!modalVerEstudios);
    }

   const abrirModalInsertar=()=>{
        setModalInsertar(!modalInsertar);
    }

    const abrirModalEstudio=()=>{
        setModalAgregarEstudio(!modalAgregarestudio);
    }

    const abrirModalEliminar=()=>{
        setModalElimnar(!modalEliminar);
    }


    const peticionPost=async()=>{
        var f = new FormData();
        f.append("nombre",  pacienteSeleccionado.nombre );
        f.append("numeroIdentificacion", pacienteSeleccionado.dni);
        f.append("TipoOperador", 'PACIENTE');
        f.append("id_Derivante", '1');
        f.append("email", pacienteSeleccionado.correo);
        f.append("direccion", pacienteSeleccionado.direccion);
        f.append("localidad", pacienteSeleccionado.localidad);
        f.append("telefono", pacienteSeleccionado.telefono);
        f.append('METHOD', 'POST');
      
        await axios.post(baseUrl,f)
        .then(response=>{
            setData(datas.concat(response.data));
            console.log(response.data);
            abrirModalInsertar();
       }).catch(error=>{
        console.log(error);
    })
    }


    const insertEstudio=async()=>{
        var f = new FormData();
        f.append("codigo", '1');
        f.append("nombre", estudioSeleccionado.nombre);
        f.append("fechanetrega", estudioSeleccionado.fechanetrega);
        f.append("fechapedido", estudioSeleccionado.fechapedido);
        f.append("estado", '0');
        f.append('METHOD', 'insertEstudio');
      
        await axios.post(baseUrl,f)
        .then(response=>{
            setDataEstudios(datosEstudios.concat(response.data));
            abrirModalEstudio();
            
       }).catch(error=>{
        console.log(error);
    })
    }
   
    
        const listadpDerivante=async()=>{
         
            await axios.get(baseUrl,{params:{opcion: 'Pacientes'}})
            .then(response=>{
              setData(response.data);
            }).catch(error=>{
              console.log(error);
            })
          }

          const listadoestudio=async()=>{
         
            await axios.get(baseUrl,{params:{opcion: 'Estudios'}})
            .then(response=>{
              setDataEstudios(response.data);
            }).catch(error=>{
              console.log(error);
            })
          }

          const peticionDelete=async()=>{
            var f = new FormData();
            f.append("METHOD", "DELETE");
            await axios.post(baseUrl,f, {params:{id:pacienteSeleccionado.id}})
            
            .then(response=>{
                
                setData(datas.filter(paciente=>paciente.id!==pacienteSeleccionado.id));
             
                abrirModalEliminar();
           }).catch(error=>{
               console.log('aasdasdasdasdasdasdas');
           })
  

        }

        useEffect(()=>{
       
            listadoestudio();
            listadpDerivante();
          },[])


  
     return(
        
        <div>
            <Header></Header>
             <br></br>
                 <h3><p className="text-info">Gestion Derivante</p> </h3>
             <br></br>
    
            <button className="btn btn-outline-primary"
                   onClick={()=>abrirModalInsertar()}
             >Agregar Paciente</button>
             
             <table className="table table-hover">
                <thead>
                    <th>Nombre</th>
                    <th>DNI</th>
                    <th>Telefono</th>
                    <th>Localidad</th>
                    <th>Acciones para Estudios</th>
                    <th></th>
                </thead>
   
                <tbody>
                {datas.map(derivantes=>(
                    <tr key={derivantes.id}>
                    <td> {derivantes.nombre}</td>
                    <td> {derivantes.numeroIdentificacion}</td>
                    <td> {derivantes.telefono}</td>
                    <td> {derivantes.localidad}</td>
                    <td>

                   


                        <button className="btn btn-link" onClick={()=>abrirModalEstudio()}>
                            <span className="input-group-text" id="basic-addon">
                            <i className="fa fa-plus" aria-hidden="true"></i>
                            </span>  </button>
                     
                        <button className="btn btn-link"  >
                        <span className="input-group-text" onClick={()=>abrirModalVerEstudios(datas.id)} aria-hidden="true" id="basic-addon">
                        <i className="fa fa-list" aria-hidden="true"></i>
                    
                            </span> 
                         </button>

                         
                        <button className="btn btn-link"  onClick={()=>abrirModalEliminar()}>
                        <span className="input-group-text" aria-hidden="true" id="basic-addon">
                        <i className=" fa fa-trash" aria-hidden="true"></i>
                    
                            </span> 
                         </button>
                     
                    </td>
 
 
                    </tr>
                ))}
            </tbody>
            </table>

            <Modal isOpen={modalInsertar}>
                    <ModalHeader><p className="text-info">Nuevo Pacientes/Derivante</p></ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label>Nombre: </label>
                        <input type="text" className="form-control" name="nombre" onChange={handleChange}/>
                        <label>Documento: </label>
                        <input type="text" className="form-control" name="dni" onChange={handleChange}/>
                        <label>Direccion </label>
                        <input type="text" className="form-control" name="direccion" onChange={handleChange}/>
                        <label >Localidad</label>
                        <input className="form-control" type="text"  name="localidad" onChange={handleChange} ></input>
                        <label >Telefono</label>
                        <input className="form-control" type="tel" name="telefono" onChange={handleChange}></input>
                        <label >Correo</label>
                        <input className="form-control" type="email" name="correo" onChange={handleChange}></input>
                
                   </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary" onClick={()=>peticionPost()}>Grabar</button>{"   "}
                        <button className="btn btn-info" onClick={abrirModalInsertar}>Cancelar</button>
                      
                    </ModalFooter>
            </Modal>

            <Modal isOpen={modalAgregarestudio}>
                    <ModalHeader><p className="text-info">Agregar Pedido de Estudio</p></ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label>Fecha Pedido: </label>
                        <input type="date" className="form-control" name="fechapedido" onChange={handleChangestudio}/>
                        <label>Fecha de entrega: </label>
                        <input type="date" className="form-control" name="fechanetrega" onChange={handleChangestudio}/>
                        <label>Nombre de Estudio: </label>
                        <input type="text" className="form-control" name="nombre" onChange={handleChangestudio}/>
                            
                   </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary" onClick={()=>insertEstudio()}>Grabar</button>{"   "}
                        <button className="btn btn-info"  onClick={abrirModalEstudio}>Cancelar</button>
                      
                    </ModalFooter>
            </Modal>


            <Modal isOpen={modalEliminar}>
                    <ModalBody><p className="text-info">
                    Desea Eliminar el Paciente ? {pacienteSeleccionado && pacienteSeleccionado.nombre}</p>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn-outline-primary" onClick={abrirModalEliminar}>No</button>{"   "}
                        <button className="btn-outline-danger" onClick={()=>peticionDelete()}>SI</button>
                        
                    </ModalFooter>
            </Modal>

            <Modal isOpen={modalVerEstudios} >
                    <ModalBody><p className="text-info">
                    Listado de Pedidos Estudios                    </p></ModalBody>
                 
                    {datosEstudios.length ===0  ? null :  
                     
                     datosEstudios.map((idordenestudio)=>(
                        <Estudiopacientes 
                              key={idordenestudio.codigo}
                              idpacienteEstudio={idordenestudio}
                        />
                        ))
                        }   
                       
                    <ModalFooter>
                   
                        <button className="btn-outline-primary" onClick={abrirModalVerEstudios}>Volver</button>
                    </ModalFooter>
            </Modal>

           
           

            
            
        </div>

        



    );


}
export default Derivante;